// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CATEGORY_SELECT_NO_CATEGORIES = "Nie je mo\u017en\u00e9 vybra\u0165 \u017eiadnu kateg\u00f3riu";
